import { isNoise } from 'libs/is-noise';
import ProjectStateHandler from './project-state-handler';
// State transitions:
// PreparingMedia ─┬────────────────────────────┬──▸ Transcribing
//    ▴            └──▸ NofaststartConversion ──┘          │
//    │                                                    ▾
//    │                                              WordsArriving
//    │                                                    │
//    │                                                    ▾
// LoadingProject ───────────────────────────────────▸ Completed
export default class MediaProcessingHandler extends ProjectStateHandler {
    constructor(messageStream) {
        super(messageStream, 'loading-project');
        this.handleMediaIdentificationProgress = ({ data }) => {
            // When transcripiton is completed (e.g. in case of uploaded trsx)
            // we do not want to change the state during recording conversion
            if (this.status === 'completed') {
                return;
            }
            if (data.kind === 'Error' && data.error === 'Unknown duration.') {
                this.updateStatus('nofaststart-conversion');
            }
        };
        this.handleTranscriptionTrackingStarted = () => this.updateStatus('transcribing');
        this.handleRecognitionProgress = (message) => {
            if (message.data.word !== null) {
                if (isNoise(message.data.word.text)) {
                    return;
                }
                if (this.status === 'transcribing' || this.status === 'loading-project') {
                    this.updateStatus('words-arriving');
                }
            }
        };
        this.handleTranscriptionTrackingCompleted = () => this.updateStatus('completed');
        this.handleTranscriptionTrackingFailed = () => this.updateStatus('completed');
        this.handleChainCompleted = () => this.updateStatus('completed');
        this.addStreamListener('MediaIdentification', 'Progress', this.handleMediaIdentificationProgress);
        this.addStreamListener('TranscriptionTracking', 'Started', this.handleTranscriptionTrackingStarted);
        this.addStreamListener('TranscriptionStreaming', 'Progress', this.handleRecognitionProgress);
        this.addStreamListener('TranscriptionTracking', 'Completed', this.handleTranscriptionTrackingCompleted);
        this.addStreamListener('TranscriptionTracking', 'Failed', this.handleTranscriptionTrackingFailed);
        // NOTE: Projects uploaded together with a trsx run no transcription at all
        // (see isUploadOnly), so no TranscriptionTracking message ever arrives and
        // the initial 'loading-project' would never be left. The chain always
        // reports its own completion, so use that as the fallback exit.
        this.addStreamListener('ChainControl', 'Completed', this.handleChainCompleted);
    }
    projectReloaded(project) {
        if (project.processingState !== 'InProgress') {
            this.updateStatus('completed');
        }
    }
}
